module.exports = {

    props: {
        data: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            course: this.data.course,
            schedules: this.data.schedules,
        }
    },

    computed: {
        courseOptions() {

            if (['career-safe', 'package', 'mike-holt', 'mike-holt-offline'].includes(this.course.provider)) {
                return {
                    payload: {
                        address: '',
                        state: '',
                        city: '',
                        zip: ''
                    }
                };
            }

            if (['schedule', 'webinar'].includes(this.course.provider)) {
                return {
                    payload: {},
                    schedules: this.schedules
                };
            }

            return {
                payload: {},
            };
        }
    }
}
